import {Colors} from "@qnpm/q-theme"
import SizeUtil from "../../../../Utils/SizeUtil";
import { StyleSheet } from 'react-native';

const {scenes: {baseColor}} = Colors;

export const styles = StyleSheet.create({
    container: {
        paddingVertical: 12,
        marginRight: 7,
        marginLeft: 15,
        flex: 1,
        flexDirection: 'row-reverse',
        justifyContent: 'flex-start',
        overflow: 'hidden'
    },
    containerReverse: {
    },

    buttonOuter: {
        width: '25%'
    },
    button: {
        paddingHorizontal: 10,
        height: 28,
        backgroundColor: 'transparent',
        borderWidth: StyleSheet.hairlineWidth,
        borderColor: '#E7E7E7',
        borderRadius: 99,
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 8,
    },
    buttonText: {
        fontSize: 12,
        color: baseColor.text2
    },
    borderLine: {
        height: StyleSheet.hairlineWidth,
        right: 6,
        top: 0,
        width: '100%',
        backgroundColor: baseColor.line,
        position: 'absolute',
    },
});
